'use strict';

import angular from 'angular';
import changePasswordController from './changePassword.controller';

export default angular.module('bfastCaptureManagerApp.changePassword', [])
  .controller('changePasswordController', changePasswordController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/changePassword/index.js